import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'titleCampaign' })
export class TitleCampaignPipe implements PipeTransform {
    transform(value: string) {
        const maxLengthDisplay = 60;
        if (value.length >= maxLengthDisplay) {
            value = `${value.substring(0, maxLengthDisplay)}...`;
        }
        return value;
    }
    
}